import Divider from '@cobliteam/ui/components/Divider';
import Skeleton from '@cobliteam/ui/components/Skeleton';
import { cn } from '@cobliteam/ui/utils';
import type { Table } from '@tanstack/react-table';
import type React from 'react';
import { memo } from 'react';
import DataTableFilters from '../components/DataTableFilters';
import type { TFilterKeys, TFilterOptions } from '../types';

type FiltersProps<TData> = {
  filtersDef?: any[];
  filtersLoading?: boolean;
  filtersOptions?: TFilterOptions;
  favoriteFilters?: TFilterKeys[];
  datePicker?: React.ReactNode;
  table: Table<TData>;
  onChangeFilter: (value: any) => void;
  onSelectedFiltersChange: (keys: TFilterKeys[]) => void;
};

const FiltersSkeleton = () => {
  return (
    <div className='flex w-72 gap-2'>
      <Skeleton width='100%' height={32} />
      <Skeleton width='100%' height={32} />
      <Skeleton width='100%' height={32} />
    </div>
  );
};

const DataTableSectionFilters = <TData,>({
  filtersDef,
  favoriteFilters,
  datePicker,
  table,
  filtersOptions,
  onChangeFilter,
  onSelectedFiltersChange,
  filtersLoading = false,
}: FiltersProps<TData>) => {
  if (!(filtersDef || datePicker)) return null;

  return (
    <>
      <div className='grid grid-cols-12 items-center gap-2 space-y-2 tablet:space-y-0'>
        {datePicker ? <div className='col-span-12 tablet:col-span-3'>{datePicker}</div> : null}
        <div className={cn('col-span-12 tablet:col-span-12', datePicker ? 'tablet:col-span-9' : '')}>
          <div className='flex flex-wrap items-center justify-start tablet:justify-end gap-2'>
            {filtersLoading ? <FiltersSkeleton /> : null}
            {filtersDef && !filtersLoading ? (
              <DataTableFilters
                filtersDef={filtersDef}
                filtersOptions={filtersOptions}
                onChangeFilter={(value) => {
                  table.resetPagination();
                  onChangeFilter(value);
                }}
                onSelectedFiltersChange={onSelectedFiltersChange}
                favoriteFilters={favoriteFilters}
              />
            ) : null}
          </div>
        </div>
      </div>
      <Divider />
    </>
  );
};

export default memo(DataTableSectionFilters);
